import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as Pusher from 'pusher-js';



@Injectable()
export class PusherService {
  pusher: any;
  channel: any;
  channel1: any;
  channel2: any;

  constructor(private http: HttpClient) {
    this.pusher = new Pusher(environment.pusher.key, {
      cluster: environment.pusher.cluster,
      encrypted: true
    });
    this.channel = this.pusher.subscribe('bidjones');
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/pusher.service.ts